import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import AppTopBar2 from './common/app-top-bar2';
import AppLoading from './common/app-loading';
import { Button, Box } from '@mui/material';
import { AppHelper } from '../AppHelper';
import EssayView from './essay/essay-view';

export default function PageEssayShare() {
  const { shareId } = useParams();
  const [searchParams] = useSearchParams();
  const browseSource = searchParams.get('source');
  const [isLoading, setIsLoading] = useState(true);
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [viewMode, setViewMode] = React.useState('VIEW');
  const [pageEssayId, setPageEssayId] = React.useState('');
  const [recEssay, setRecEssay] = React.useState({});
  const [isSa, setIsSa] = React.useState(false);
  const [shareOK, setShareOK] = useState(false);
  
  useEffect(()=>{
    const fetchIAM = async()=>{
      var _res = await AppHelper.apiPost('api/account/iam', {token: 'oUser.token'});
      if(!_res || !_res.status || !_res.data || !_res.data.isSa){
        return;
      }
      setIsSa(true);
    }
    fetchIAM();
  });
  
  useEffect(() => {
    AppHelper.apiAuditPost("P-SA", "");
  }, []);

  useEffect(()=>{
    const fetchShareInfo = async()=>{
      setIsLoading(true);
      var _res = await AppHelper.apiPost('api/essay/share/get', {shareId:shareId});
      setIsLoading(false);
      if(!_res || !_res.status || !_res.data){
        console.error(_res);
        return;
      }
      setShareOK(true);
      setPageEssayId(_res.data.essayId);
      fetchEssayDetail(_res.data.essayId);
    }
    const fetchEssayDetail = async(argEssayId) =>{
      setIsLoading(true);
      var _res = await AppHelper.apiPost('api/essay/detail', {token: 'oUser.token', essayId:argEssayId});
      setIsLoading(false);
      if(!_res || !_res.status){
        return;
      }
      var _recEssay = _res.data;
      _recEssay.email = _res.email;
		  _recEssay.student = _res.student;
		
		  setRecEssay(_recEssay);
    };
    fetchShareInfo();
  }, [shareId]);
 
  const mobileOpenClick = (arg)=>{
    setMobileOpen(!mobileOpen);
  };
  
  const essayViewDone = (arg) =>{    
    setViewMode('VIEW');
  };
  return (
    <Box sx={{display:'flex'}}>
      <AppTopBar2 mobileOpen={mobileOpen} mobileOpenClick={mobileOpenClick} hideAttr={true} />
      {isLoading? (
        <AppLoading />
      ):(
      <>
      <Box
        component="main"
        sx={{ flexGrow: 1, p: 3, 
          width: '100%',
          marginTop:'50px' 
        }}
      >
        {
          shareOK &&(
            <>    
            <EssayView isSa={isSa} essayFormDone={essayViewDone} essayId={recEssay.essayId} isShared={true} scroll2End={browseSource=='qrcode'}></EssayView>
            </>
          )
        }
      </Box>
      </>
      )}
    </Box>
  );
}
